
export const unauthenticatedPaths = new Set([
  '/contact-us',
  '/landing',
  '/support',
  '/view-user-agreement',
  '/view-privacy-policy',
]);
